import * as React from 'react';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';

import { Typography } from '../../Typography';
import useStyles from './TabLabel.styles';

export interface ITabLabelProps {
  children: string | number;
  tabKey: string;
  onSelect(key: string): unknown;
  disabled?: boolean;
  active?: boolean;
}

export const tabLabelLocators = createLocators({
  name: 'TabLabel',
  componentLocators: ['tabLabelItem'],
});
const { locators } = tabLabelLocators();

const TabLabel: React.FC<ITabLabelProps> = ({
  children,
  tabKey,
  onSelect,
  disabled = false,
  active = false,
}) => {
  const classes = useStyles();

  return (
    <button
      type="button"
      role="tab"
      id={`tablabel-id-${tabKey}`}
      aria-controls={`tabpanel-id-${tabKey}`}
      aria-selected={active}
      disabled={disabled}
      className={clsx(
        classes.root,
        disabled && classes.disabled,
        active && classes.selected,
      )}
      onClick={() => onSelect(tabKey)}
      {...locators.tabLabelItem({ tabKey })}
    >
      <Typography
        className={classes.tabLabelText}
        as="div"
        hideOverflow={true}
        variant={active ? 'heading01' : 'body01'}
        noWrap
      >
        {children}
      </Typography>
    </button>
  );
};

export default TabLabel;
